module.exports = __webpack_public_path__ + "static/media/See_freebies.ceacce8e.svg";